import { memo } from 'react';
import OverflowChips from '../../components/OverflowChips';
import FindingRefChip from './FindingRefChip';

/** One Fund made from a Probe, as its chip shows it. */
export interface SampleFindRef {
    id: string;
    /** The Fundzettelnummer. */
    label: string;
    /** The Fund's editor, in its own project. */
    to: string;
}

/** Same Funde, in the same order — the cell is handed a fresh array each time. */
function sameFinds(
    before: { finds: SampleFindRef[] },
    after: { finds: SampleFindRef[] }
) {
    return (
        before.finds.length === after.finds.length &&
        before.finds.every(
            (find, index) =>
                find.id === after.finds[index].id &&
                find.label === after.finds[index].label
        )
    );
}

/**
 * The Probenliste's Funde column: one linking chip per Fund made from the
 * Probe, by Fundzettelnummer, only as many as fit, then a "+N" chip (see
 * OverflowChips) — the same chips the Befundliste names its Funde with.
 */
const SampleFindsCell = memo(function SampleFindsCell({
    finds
}: {
    finds: SampleFindRef[];
}) {
    return (
        <OverflowChips
            items={finds}
            getKey={(find) => find.id}
            renderChip={(find) => (
                <FindingRefChip label={find.label || '—'} to={find.to} />
            )}
        />
    );
}, sameFinds);

export default SampleFindsCell;
